// Wave RW.5 (2026-05-18) — /main/rfq URL deep link 파서.
// CommonJS — 메인 jest 에서 require 로 단위 테스트 가능하도록.
// 책임: 형식 검증만. 존재/권한 검증은 RFQDetail 의 fetch 가 담당.
//
// 반환:
//   { view: 'list', id: null }                    — /main/rfq 또는 /main/rfq/
//   { view: 'new',  id: null }                    — /main/rfq/new
//   { view: 'detail', id: <number> }              — /main/rfq/<양의 정수>
//   { view: 'list', id: null, invalid: true }     — /main/rfq/<invalid 형식> (RFQPage 가 list 로 redirect)
//
// invalid 정의: segment 가 존재하지만 'new' 가 아니고 양의 정수 정규식 미일치
//   - /main/rfq/0      (0 금지)
//   - /main/rfq/-1     (음수)
//   - /main/rfq/abc    (비숫자)
//   - /main/rfq/01     (leading zero 금지)
// 깊은 path (/main/rfq/123/foo) 는 invalid 가 아닌 list 로 — 잘못된 deep link 는 silently fall-through

function parseRfqPath(pathname) {
  if (typeof pathname !== 'string') return { view: 'list', id: null };
  var m = pathname.match(/^\/main\/rfq(?:\/([^/]*))?\/?$/);
  if (!m) return { view: 'list', id: null };
  var seg = m[1];
  if (seg === undefined || seg === '') return { view: 'list', id: null };
  if (seg === 'new') return { view: 'new', id: null };
  if (/^[1-9]\d*$/.test(seg)) return { view: 'detail', id: parseInt(seg, 10) };
  return { view: 'list', id: null, invalid: true };
}

module.exports = { parseRfqPath: parseRfqPath };
